import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "ControlTVATableWrapper",
  style: {"overflow-y":"auto","max-height":"80vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex my-4 justify-center"
}
const _hoisted_3 = {
  key: 1,
  id: "ControlTVATableContentWrapper"
}
const _hoisted_4 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.getControlItems().length && !_ctx.noDataReceived)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.getControlItems().length || _ctx.noDataReceived)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_data_table, {
            items: _ctx.getControlItems(),
            headers: _ctx.getControlHeaders(),
            itemKey: "vatRate",
            dense: "",
            "data-cy": "control-table",
            "hide-default-footer": ""
          }, {
            top: _withCtx(() => [
              _createVNode(_component_v_toolbar, { flat: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("control-tva.control")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            "item.tax": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.tax) + " % ", 1)
            ]),
            "item.theoricalCredit": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.theoricalCredit)), 1)
            ]),
            "item.realCredit": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.realCredit)), 1)
            ]),
            "item.gap": _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(item.gap)), 1)
            ]),
            _: 1
          }, 8, ["items", "headers"]),
          _createVNode(_component_v_data_table, {
            items: _ctx.productAccountGroups,
            headers: _ctx.getProductHeaders(),
            itemKey: "vatRate",
            class: "mb-4",
            "hide-default-footer": "",
            dense: ""
          }, {
            top: _withCtx(() => [
              _createVNode(_component_v_toolbar, { flat: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("control-tva.product-accounts")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            "item.vatRate": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.vatRate) + " % ", 1)
            ]),
            "item.balance": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.balance)), 1)
            ]),
            "item.accounts": _withCtx(({ item }) => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.accounts, (account) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: account.name
                  }, _toDisplayString(account.name) + " - " + _toDisplayString(_ctx.$t("control-tva.credit")) + " " + _toDisplayString(_ctx.newCommonFormatCurrency(account.balance)), 1))
                }), 128))
              ])
            ]),
            "item.tvaAmount": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency((item.balance * item.vatRate) / 100)), 1)
            ]),
            _: 1
          }, 8, ["items", "headers"]),
          _createVNode(_component_v_data_table, {
            items: _ctx.tvaAccountGroups,
            headers: _ctx.getTVAHeaders(),
            itemKey: "vatRate",
            dense: "",
            class: "mb-4",
            "hide-default-footer": ""
          }, {
            top: _withCtx(() => [
              _createVNode(_component_v_toolbar, { flat: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("control-tva.tva-accounts")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            "item.vatRate": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.vatRate) + " % ", 1)
            ]),
            "item.balance": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.balance)), 1)
            ]),
            "item.accounts": _withCtx(({ item }) => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.accounts, (account) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: account.name
                  }, _toDisplayString(account.name) + " - " + _toDisplayString(_ctx.$t("control-tva.credit")) + " " + _toDisplayString(_ctx.newCommonFormatCurrency(account.balance)), 1))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items", "headers"])
        ]))
      : _createCommentVNode("", true)
  ]))
}